/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleGroupAssignmentCreate
 */
export interface VehicleGroupAssignmentCreate {
    /**
     * 
     * @type {string}
     * @memberof VehicleGroupAssignmentCreate
     */
    vehicleGroupId: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleGroupAssignmentCreate
     */
    vehicleId: string;
}

/**
 * Check if a given object implements the VehicleGroupAssignmentCreate interface.
 */
export function instanceOfVehicleGroupAssignmentCreate(value: object): value is VehicleGroupAssignmentCreate {
    if (!('vehicleGroupId' in value) || value['vehicleGroupId'] === undefined) return false;
    if (!('vehicleId' in value) || value['vehicleId'] === undefined) return false;
    return true;
}

export function VehicleGroupAssignmentCreateFromJSON(json: any): VehicleGroupAssignmentCreate {
    return VehicleGroupAssignmentCreateFromJSONTyped(json, false);
}

export function VehicleGroupAssignmentCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleGroupAssignmentCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'vehicleGroupId': json['vehicleGroupId'],
        'vehicleId': json['vehicleId'],
    };
}

export function VehicleGroupAssignmentCreateToJSON(json: any): VehicleGroupAssignmentCreate {
    return VehicleGroupAssignmentCreateToJSONTyped(json, false);
}

export function VehicleGroupAssignmentCreateToJSONTyped(value?: VehicleGroupAssignmentCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vehicleGroupId': value['vehicleGroupId'],
        'vehicleId': value['vehicleId'],
    };
}

